import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IGaUser } from '../../../models/ga.model';
import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';

interface IProps {
  data: IGaUser;
}

const HomepageVisitChart: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();
  const series: ApexOptions['series'] = [
    data.revisitUserCount || 0,
    data.newUserCount || 0,
  ];

  const options: ApexOptions = {
    labels: [t('class.dashboard.column13'), t('class.dashboard.column14')],
    legend: { position: 'bottom', fontFamily: 'Roboto' },
    dataLabels: {
      style: {
        colors: ['#ffffff'],
        fontFamily: 'Roboto'
      },
      background: {
        enabled: true,
        borderWidth: 0,
        opacity: 1,
        foreColor: '#000000',
        dropShadow: { enabled: false },
      },
      dropShadow: { enabled: false },
      formatter(val: string | number | number[], opts?: any): string | number {
        let count =
          opts.seriesIndex === 0 ? data.revisitUserCount : data.newUserCount;
        if (typeof val === 'number') {
          // @ts-ignore
          return [`${Math.round(val * 10) / 10}%`, `${count} ${t('class.dashboard.text2')}`];
        }
        // @ts-ignore
        return [String(val), count];
      },
    },
    colors: ["#8bd0db","#cde9ee"],
    states: {
      hover: {
        filter: {
          type: 'none'
        }
      }
    },
    tooltip: {
      fillSeriesColor: false
    }
  };

  return <Chart series={series} options={options} type="pie" />;
};

export default HomepageVisitChart;
